(function($) {
  $(document).ready(function() {
    var priceConnectedToCurrencies = {
      productPriceEl: false,
      newPriceEl: $('<span class="money">'),
      init: function() {
        this.productPriceEl = $('.cpb-product-price');

        // Format the price using window.productData
        const priceCents = window.productData?.price || 0;
        const currency = window.productData?.currency || '';
        const formattedPrice = `${currency}`;

        this.newPriceEl.text(formattedPrice);

        // Hide original and append formatted
        this.productPriceEl.closest('.row').hide().after(
          $('<div class="row">').append(
            $('<div class="cpb-product-full-price">').append(
            $('<div class="cpb-product-price">').append(this.newPriceEl)
            )
          )
        );

        currencyConverter.convertCurrencies();

        $('body').on('CPB_ON_OPTIONS_UPDATE', function() {
          this.update();
        }.bind(this));
      },
      update: function() {
        // Clear any data-currency attributes
        var attributesToRemove = [];
        for (var i = 0; i < this.newPriceEl[0].attributes.length; i++) {
          var attr = this.newPriceEl[0].attributes[i].name;
          if (attr.indexOf('data-currency') === 0) attributesToRemove.push(attr);
        }
        for (var i = 0; i < attributesToRemove.length; i++) {
          this.newPriceEl.removeAttr(attributesToRemove[i]);
        }

        // Update price from global productData again
        const priceCents = window.productData?.price || 0;
        const currency = window.productData?.currency || '';
        const formattedPrice = `${currency}`;
        this.newPriceEl.text(formattedPrice);

        currencyConverter.convertCurrencies();
      }
    }

    function waitForCPB() {
      $('.cpb-panels-container').length ? init() : requestAnimationFrame(waitForCPB);
    }

    waitForCPB();

    function init() {
      priceConnectedToCurrencies.init();
    }
  });
})(jQuery);
